import React from 'react'
import styled, {withTheme} from 'styled-components'
import {get} from 'lodash'
import config from 'config'
import {LANDING_PAGE_LANGUAGES} from 'const'

const getFooter = props => props.theme.shell.footer
const getOnelogLogo = props => getFooter(props).onelogLogo || {}
const getOnelogLogoHeight = props => getOnelogLogo(props).height || '36px'
const getOnelogLogoWidth = props => getOnelogLogo(props).width || '146px'
const getOnelogLogoMargin = props => getOnelogLogo(props).margin || '0'

const FooterOnelogLogoIcon = styled.img`
  height: ${getOnelogLogoHeight};
  width: ${getOnelogLogoWidth};
  margin: ${getOnelogLogoMargin};
`

const FooterOnelogLogoContainer = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`

const getFooterLogo = (logoColor, lang = 'de') => {
  const validLang = LANDING_PAGE_LANGUAGES.includes(lang) ? lang : 'de'
  return `${config.url}/assets/brands/onelog/logos/${logoColor}-${validLang}.png`
}

const FooterOnelogLogo = ({href, lang, theme}) => {
  const logoColor = get(theme, 'shell.footer.tenants.logoColor', 'black')
  return (
    <FooterOnelogLogoContainer href={href} target="_blank">
      <FooterOnelogLogoIcon lang={lang} src={getFooterLogo(logoColor, lang)} />
    </FooterOnelogLogoContainer>
  )
}

export default withTheme(FooterOnelogLogo)
